export default __webpack_public_path__ + "static/media/logo-full.b460ef05.svg";